// extracted by mini-css-extract-plugin
export default {"header":"mR","light":"nR","dark":"oR","headertitle":"pR","fname":"qR","headerContent":"rR","right":"sR","descriptionwrapper":"tR","appear":"uR","second":"vR","third":"wR","forth":"xR"};
    if(module.hot) {
      // 1737143664624
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  